<input
  (input)="onInputChange($event)"
  [max]="max"
  [value]="value"
  [disabled]="!max"
  class="form-range"
  min="0"
  step="1"
  type="range"
/>
